import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import useDxpPreviewParam from './useDxpPreviewParam';
const useNavigateWithPreview = () => {
    const navigate = useNavigate();
    const dxpPreviewParam = useDxpPreviewParam();
    const navigateWithPreview = useCallback((pathname, params, options) => {
        navigate({
            pathname,
            search: params
                ? `?${params}${dxpPreviewParam ? '&' + dxpPreviewParam : ''}`
                : `?${dxpPreviewParam}`,
        }, options);
    }, [dxpPreviewParam, navigate]);
    return navigateWithPreview;
};
export default useNavigateWithPreview;
//# sourceMappingURL=useNavigateWithPreview.js.map